import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { PredictionDashboard } from './PredictionDashboard';
export function Hero() {
  return <section className="relative pt-20 pb-12 md:pt-28 md:pb-16 px-4 overflow-hidden" data-id="element-95">
      <div className="max-w-7xl mx-auto" data-id="element-96">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center justify-center md:justify-start mb-12" data-id="element-97">
          <img src="https://i.postimg.cc/7Z06kXm2/Gemini-Generated-Image-e5q1v8e5q1v8e5q1-removebg-preview.png" alt="VISIONGOL" className="h-12 md:h-14 w-auto" data-id="element-98" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-99">
          {/* Copy */}
          <div className="text-center md:text-left z-10" data-id="element-100">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass-card text-xs text-brand-blue font-mono uppercase tracking-[0.2em] mb-6 border-brand-blue/20" data-id="element-101">
              <Lock className="w-3 h-3" data-id="element-102" />
              Acceso Privado
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-4xl md:text-6xl font-display font-bold leading-[1.05] mb-6 tracking-tight" data-id="element-103">
              Cambia tu perspectiva. <br className="hidden md:block" data-id="element-104" />
              Cambia tus <span className="text-brand-blue" data-id="element-105">resultados.</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="text-lg md:text-xl text-gray-400 mb-8 max-w-xl mx-auto md:mx-0 leading-relaxed" data-id="element-106">
              VISIONGOL es un software de inteligencia artificial que predice
              resultados de fútbol analizando estadísticas, forma reciente,
              rendimiento de equipos y contexto de cada partido. Convierte datos
              complejos en pronósticos claros con probabilidades de victoria,
              empate, derrota y marcador probable.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="flex flex-col items-center md:items-start gap-3" data-id="element-107">
              <img src="https://i.postimg.cc/Kv5B2GjP/1999cd14-4a51-4497-9042-481c21bc7b8b.png" alt="VISIONGOL" className="max-w-xs md:max-w-sm w-full h-auto mb-2" data-id="element-108" />
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="btn-primary w-full md:w-auto px-8 py-4 rounded-xl font-display font-bold text-base md:text-lg uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-109">
                Acceder a VISIONGOL — $6.36 USD
              </button>
              <p className="text-sm text-gray-500 font-medium flex items-center gap-2" data-id="element-110">
                <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" data-id="element-111" />
                Entrada inmediata · Disponible 24/7
              </p>
            </motion.div>
          </div>

          {/* Visual */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 1
        }} className="relative z-10 min-w-0 w-full overflow-hidden" data-id="element-112">
            <div className="absolute inset-0 bg-brand-blue/20 blur-[100px] rounded-full pointer-events-none" data-id="element-113" />
            <PredictionDashboard data-id="element-114" />
          </motion.div>
        </div>
      </div>
    </section>;
}